import React from "react";
import Header_m from '../header/Header.js';
import PictureBanner from "../Banner/PictureBanner.js";
import FreeQuoteBlock from '../Home/FreeQuote.js';
import Footer_m from '../footer/Footer.js';

import vegasContact from '../../img/banners/vegasContact.jpg';
import ContactCard from "../Contact/ContactCard.js";

import backyard from '../../img/stone/backyard.jpg';
import backyard2 from '../../img/stone/backyard2.jpg';
import FreeQuoteButton from "../Home/button/freequoteButton.js";

const Contact = () => {
    return (
        <div>
            {/* <Header_m></Header_m> */}

            {/* Actual code for page */}
            <div className="container">

                {/* Vagas vanner picture */}
                <PictureBanner picture={vegasContact}></PictureBanner>

                <div class="row show-on-large hide-on-med-and-down">

                    <div class="col s12 ">
                        <div class="card ">

                            <div class="col s6">
                                <ContactCard></ContactCard>
                            </div>
                            <div class="col s6">

                                <FreeQuoteBlock></FreeQuoteBlock>

                            </div>
                        </div>
                    </div>
                </div>
                

                {/* For Mobile version */}
                <div class="hide-on-large-only">

                    <div class="col s12">
                        <div class="card">

                            <div class="col s6">
                                <ContactCard></ContactCard>
                            </div>
                            <div class="col s6">

                                <FreeQuoteBlock></FreeQuoteBlock>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Footer_m></Footer_m>
        </div>

    )
}

export default Contact;